import { PaletteOptions, PaletteColorOptions } from "@mui/material";

export const palette: PaletteOptions & {
    appleWallet: PaletteColorOptions,
    androidWallet: PaletteColorOptions,
} = {
    mode: 'light',
    primary: {
        main: '#C40109',
        light: '#E7999D',
        dark: '#A20107',
        contrastText: '#FFFFFF',
    },
    secondary: {
        main: "#E4E8E8",
        light: "#FAFAFA",
        dark: "#C8C8C8",
        contrastText: "#666666",
    },
    error: {
        main: '#C40109',
        light: '#E7999D',
        dark: '#A20107',
        contrastText: '#FFFFFF',
    },
    warning: {
        main: '#F7A700',
        light: '#FCDC99',
        dark: '#D59000',
        contrastText: '#FFFFFF',
    },
    info: {
        main: '#00A9AE',
        light: '#99DDDF',
        dark: '#00888C',
        contrastText: '#FFFFFF',
    },
    success: {
        main: '#88A926',
        light: '#CFDDA8',
        dark: '#728D20',
        contrastText: '#FFFFFF',
    },
    divider: "#E5E5E5",
    text: {
        primary: '#000000',
        secondary: '#666666',
        disabled: '#999999',
    },
    common: {
        black: '#000000',
        white: '#FFFFFF',
    },
    appleWallet: {
        main: "#000000",
        light: "#000000",
        dark: "#000000",
        contrastText: "#ffffff",
    },
    androidWallet: {
        main: "#1F1F1F",
        light: "#1F1F1F",
        dark: "#1F1F1F",
        contrastText: "#ffffff",
    },
    grey: {
        50: '#FBFBFB',
        100: '#F7F7F7',
        200: '#F0F0F0',
        300: '#E5E5E5',
        400: "#D9D9D9",
        500: '#CCCCCC',
        600: '#999999',
        700: '#666666',
    }
};